import { BetTypeEnum } from '@/ui-components/components/BetLotto/BetLotto.types'
import {
  generateDoubleNumber,
  generateEvenNumber,
  generateHighNumber,
  generateLowNumber,
  generateOddNumber,
} from './utils/useRenderItem.utils'
import { BetType } from './types'

export enum FunctionMenuEnum {
  NINETEEN_NUMBER = '19_number',
  DOUBLE = 'double',
  START_NUMBER = 'start_number',
  END_NUMBER = 'end_number',
  LOW_NUMBER = 'low_number',
  HIGH_NUMBER = 'high_number',
  ODD_NUMBER = 'odd_number',
  EVEN_NUMBER = 'even_number',
  SWAP_TWO = 'swap_two',
  SWAP_THREE = 'swap_three',
}

export enum LottoConfigKey {
  BET_ONE = 'betOne',
  BET_TWO = 'betTwo',
  BET_THREE = 'betThree',
  BET_FOUR = 'betFour',
  BET_SIX = 'betSix',
}

export const FUNCTION_MENU = [
  {
    key: FunctionMenuEnum.NINETEEN_NUMBER,
    digit: 1,
  },
  {
    key: FunctionMenuEnum.DOUBLE,
    digit: 1,
  },
  {
    key: FunctionMenuEnum.START_NUMBER,
    digit: 1,
  },
  {
    key: FunctionMenuEnum.END_NUMBER,
    digit: 1,
  },
  {
    key: FunctionMenuEnum.LOW_NUMBER,
    digit: 1,
  },
  {
    key: FunctionMenuEnum.HIGH_NUMBER,
    digit: 1,
  },
  {
    key: FunctionMenuEnum.ODD_NUMBER,
    digit: 1,
  },
  {
    key: FunctionMenuEnum.EVEN_NUMBER,
    digit: 1,
  },
  {
    key: FunctionMenuEnum.SWAP_TWO,
    digit: 2,
  },
  {
    key: FunctionMenuEnum.SWAP_THREE,
    digit: 3,
  },
]

/**
 * List of bet types that require two numbers
 */
export const TWO_NUMBER_LIST = [
  FunctionMenuEnum.NINETEEN_NUMBER,
  FunctionMenuEnum.END_NUMBER,
  FunctionMenuEnum.DOUBLE,
  FunctionMenuEnum.EVEN_NUMBER,
  FunctionMenuEnum.HIGH_NUMBER,
  FunctionMenuEnum.LOW_NUMBER,
  FunctionMenuEnum.ODD_NUMBER,
  FunctionMenuEnum.START_NUMBER,
]

/**
 * List of bet types that require three numbers
 */
export const THREE_NUMBER_LIST = [
  BetTypeEnum.THREE_TOP,
  BetTypeEnum.THREE_TOD,
  FunctionMenuEnum.SWAP_THREE,
  BetTypeEnum.THREE_FRONT,
  BetTypeEnum.THREE_UNDER,
]

export const BET_TYPES_AUTO_GENERATE_BET_NUMBER: Partial<
  Record<BetType, () => string[]>
> = {
  [FunctionMenuEnum.DOUBLE]: generateDoubleNumber,
  [FunctionMenuEnum.HIGH_NUMBER]: generateHighNumber,
  [FunctionMenuEnum.LOW_NUMBER]: generateLowNumber,
  [FunctionMenuEnum.ODD_NUMBER]: generateOddNumber,
  [FunctionMenuEnum.EVEN_NUMBER]: generateEvenNumber,
}
